import React from "react";

export default function TermsofUseText() {
  return (
    <>
      <p>
        CiberMed Inc. (“CiberMed”) provides iSort&trade; website features and
        services (“Service”).
      </p>
      By using the Service, you agree to be bound by the terms of this
      Agreement. Please read it carefully.
      <br />
      <ul>
        <li>
          You agree not to use the Service for diagnosis, treatment, cure,
          prevention, or mitigation of disease or other conditions in man or
          other animals. You acknowledge that the Service and any information
          obtained therefrom is not intended to substitute for care by a
          licensed healthcare professional.
        </li>
      </ul>{" "}
      <p>
        <b>
          THE SERVICE IS OFFERED “AS IS”, AND, TO THE EXTENT PERMITTED BY LAW,
          CIBERMED MAKES NO REPRESENTATIONS AND EXTENDS NO WARRANTIES OF ANY
          KIND, EITHER EXPRESS OR IMPLIED. CIBERMED SHALL NOT BE LIABLE FOR ANY
          CLAIMS OR DAMAGES WITH RESPECT TO ANY LOSS OR OTHER CLAIM BY YOU OR
          ANY THIRD PARTY ON ACCOUNT OF, OR ARISING FROM THE USE OF THE SERVICE.
          YOU HEREBY AGREE TO DEFEND AND INDEMNIFY CIBERMED, ITS EMPLOYEES,
          OFFICERS, AGENTS, CONSULTANTS, REPRESENTATIVES, AND VOLUNTEERS
          (“CIBERMED INC. INDEMNITEES”) FROM ANY LOSS OR CLAIM ASSERTED AGAINST
          CIBERMED INDEMNITEES ARISING FROM YOUR USE OF THE SERVICE.
        </b>
      </p>
      <ul>
        <li>
          All rights not expressly granted to you in this Agreement are reserved
          and retained by CiberMed Inc. or its licensors or content providers.
          This Agreement provides no license under any patent.
        </li>
        <li>
          You agree that this Agreement and any dispute arising under it is
          governed by the laws of the State of California, United States of
          America, applicable to agreements negotiated, executed, and performed
          within California.
        </li>
      </ul>
      <p>
        Subject to your compliance with the terms and conditions set forth in
        this Agreement, CiberMed Inc. grants you a revocable, non-exclusive,
        non-transferable right to access and make use of the Service.
      </p>
      <h6>Disclaimer</h6>
      <p>
        iSort&trade; is for research use only, and shall not be used for
        diagnosis, treatment, cure, prevention, or mitigation of disease or
        other conditions in human or other animals.
      </p>
      <p>
        {" "}
        iSort&trade; is a research tool being supplied as is, without any
        accompanying services, support, or improvements from CiberMed, unless
        otherwise stated. CiberMed makes no representations and extends no
        warranties of any kind, neither express nor implied.
      </p>
      <h6> Intellectual Property Rights</h6>
      <p>
        The core technology of iSort&trade; is patented, and is fully and
        exclusively licensed from Stanford University to CiberMed.
      </p>
      <p>
        {" "}
        Unless otherwise indicated, this iSort&trade; website (“Site”) is our
        proprietary property and all source code, databases, functionality,
        software, website designs, audio, video, text, photographs, and graphics
        on the Site (collectively, the “Content”) and the trademarks, service
        marks, and logos contained therein (the “Marks”) are owned or controlled
        by us or licensed to us, and are protected by copyright and trademark
        laws and various other intellectual property rights and unfair
        competition laws of the United States, foreign jurisdictions, and
        international conventions. The Content and the Marks are provided on the
        Site “AS IS” for your information and personal use only. Except as
        expressly provided in these Terms of Use, no part of the website and no
        Content or Marks may be copied, reproduced, aggregated, republished,
        uploaded, posted, publicly displayed, encoded, translated, transmitted,
        distributed, sold, licensed, or otherwise exploited for any commercial
        purpose whatsoever, without our express prior written permission.
      </p>
      <p>
        {" "}
        Provided that you are eligible to use the Service, you are granted a
        limited license to access and use the Service and to download or print a
        copy of any portion of the Content to which you have properly gained
        access solely for your personal, non-commercial use. We reserve all
        rights not expressly granted to you in and to the Service, the Content
        and the Marks.
      </p>
    </>
  );
}
